import React, { useRef } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { Card, Button } from '../ui';
import { FileUp, Download, X } from 'lucide-react';

const SAMPLE_CSV = `keyword,meta_title,meta_description
صابون طبيعي,Soap - Natural Soap Benefits,Natural soap made with organic ingredients for healthy skin.
صابون الارقان,Argan Soap - Moroccan Oil Benefits,Argan oil soap for moisturizing and nourishing skin.
كريم مرطب,Moisturizing Cream - Best Skincare,Deep moisturizing cream for all skin types.`;

/**
 * Modal for SEO keywords import: instructions, sample download, file picker.
 * Props: isOpen, onClose, onFileSelect(file)
 */
const SeoImportModal = ({ isOpen, onClose, onFileSelect }) => {
  const { isRTL } = useLanguage();
  const fileInputRef = useRef(null);

  const handleDownloadSample = () => {
    const blob = new Blob(['\ufeff' + SAMPLE_CSV], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'seo-keywords-import-sample.csv';
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleFileChange = (e) => {
    const file = e.target?.files?.[0];
    e.target.value = '';
    if (file) {
      onFileSelect?.(file);
      onClose();
    }
  };

  const handleChooseFile = () => {
    fileInputRef.current?.click();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50" dir={isRTL ? 'rtl' : 'ltr'}>
      <Card className="w-full max-w-md">
        <div className="flex items-center justify-between p-4 border-b border-slate-200">
          <div className="flex items-center gap-2">
            <span className="flex w-9 h-9 items-center justify-center rounded-lg bg-amber-100 text-amber-600">
              <FileUp className="w-4 h-4" />
            </span>
            <h3 className="text-lg font-semibold text-slate-900">
              {isRTL ? 'استيراد كلمات مفتاحية' : 'Import keywords'}
            </h3>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-2 rounded-lg text-slate-500 hover:bg-slate-100 hover:text-slate-700"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-5 space-y-4">
          <p className="text-sm text-slate-600">
            {isRTL
              ? 'ارفع ملف CSV يحتوي على الأعمدة: keyword (مطلوب)، meta_title، meta_description. يمكنك تحميل ملف عينة للبدء.'
              : 'Upload a CSV file with columns: keyword (required), meta_title, meta_description. Download a sample file to get started.'}
          </p>

          <div className="flex flex-col gap-2">
            <Button
              type="button"
              variant="secondary"
              className="w-full inline-flex items-center justify-center gap-2"
              onClick={handleDownloadSample}
            >
              <Download className="w-4 h-4" />
              {isRTL ? 'تحميل ملف عينة' : 'Download sample file'}
            </Button>
            <Button
              type="button"
              className="w-full inline-flex items-center justify-center gap-2 bg-amber-600 hover:bg-amber-700 text-white"
              onClick={handleChooseFile}
            >
              <FileUp className="w-4 h-4" />
              {isRTL ? 'اختر ملف للاستيراد' : 'Choose file to import'}
            </Button>
            <input
              ref={fileInputRef}
              type="file"
              accept=".csv"
              className="hidden"
              onChange={handleFileChange}
            />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default SeoImportModal;
